<template>
  <basic-master
    masterName="バース"
    insertDataPageName="addon-port-master-berth-insert"
    viewPageName="addon-port-master-berth-view"
    @callDelete="callDelete"
    @callSearch="callSearch"
    @callFetchAll="callFetchAll"
    @callUpdateOrder="callUpdateOrder"
    @updateDisplayItems="updateDisplayItems"
    :storedSearchKeyword="storedSearchKeyword"
    :data="data"
    :columns="columns"
    :pagination="true"
    :totalPages="totalPages"
    :totalItems="totalItems"
    :currentPage="currentPage"
    :displayItems="displayItems"
    :incrementSearch="false"
    :sortable="true"
    :editable="false"
    ref="basicMaster"
  >
  </basic-master>
</template>

<script>

import BasicMaster from "../components/BasicMaster";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");
export default {
  components: {
    BasicMaster
  },
  data() {
    return {
      totalPages: 0,
      totalItems: 0,
      currentPage: 0,
      displayItems: {
        number: 10
      },
      columns: [
        {
          displayName:"バース名（和）",
          inputType: "string",
          key: "name",
          searchable: true,
        },
        {
          displayName:"バース名（英）",
          inputType: "string",
          key: "name_en",
          searchable: true,
        },
        {
          displayName:"略称",
          inputType: "string",
          key: "label",
          cellClass: "berth-short-name",
          searchable: true,
        },
        {
          displayName:"バースコード",
          inputType: "string",
          key: "code",
          searchable: true,
        },
        {
          displayName:"管理コード",
          inputType: "string",
          key: "admin_code",
          searchable: true,
        },
        {
          displayName:"カラーコード",
          inputType: "color",
          key: "color",
          searchable: false,
        },
      ],
      data: [],
      storedSearchKeyword: "",
      lastSearchCondition: {}
    }
  },
  async created() {
    this.displayItems = {
      number: this.storedMasterSearchCondition.berth.limit ? this.storedMasterSearchCondition.berth.limit : 10
    }
    this.refreshData(this.$route.params.lastSearchCondition)
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      storedMasterSearchCondition: state => state.storedMasterSearchCondition
    }),
  },
  methods: {
    ...mapActions(["fetchBerths", "updateBerth", "deleteBerth", "searchBerths", "updateBerthOrders", "setStoredMasterSearchCondition"]),
    updateDisplayItems(number) {
      this.displayItems = number
    },
    async refreshData(lastSearchCondition) {
      let query = {}
      if (lastSearchCondition) {
        query = lastSearchCondition
        this.currentPage = lastSearchCondition.page
        this.storedSearchKeyword = lastSearchCondition.name ? lastSearchCondition.name : ""
      } else {
        query = {
          limit: this.displayItems.number,
          page: this.currentPage,
        }
      }
      let payload = {
        portId: this.selectedPort.id,
        query: query
      }
      this.$vs.loading()
      this.setStoredMasterSearchCondition({ ...this.storedMasterSearchCondition, berth: payload.query }) // ページ表示件数を永続化するため検索条件を保存
      let res = await this.searchBerths(payload)
      this.$vs.loading.close()

      this.data = res.berths
      this.totalPages = res.pageable.total_pages
      this.totalItems = res.pageable.total_elements
    },
    async callFetchAll() {
      let payload = {
        portId: this.selectedPort.id,
      }
      this.$vs.loading()
      let res = await this.fetchBerths(payload)
      this.$vs.loading.close()
      this.data = res.berths
      this.$refs.basicMaster.forceUpdateTable(this.data)
    },
    async callSearch(condition) {
      if (Object.prototype.hasOwnProperty.call(condition, "keyword")) this.storedSearchKeyword = condition.keyword
      let payload = {
        portId: this.selectedPort.id,
        query: {
          limit: condition.limit,
          page: condition.page,
        }
      }
      if (this.storedSearchKeyword) payload.query.name = this.storedSearchKeyword // TODO: 検索の仕様確認
      this.$vs.loading()
      this.setStoredMasterSearchCondition({ ...this.storedMasterSearchCondition, berth: payload.query }) // ページ表示件数を永続化するため検索条件を保存
      let res = await this.searchBerths(payload)
      this.$vs.loading.close()
      this.data = res.berths
      this.totalPages = res.pageable.total_pages
      this.totalItems = res.pageable.total_elements
      this.currentPage = condition.page

      this.lastSearchCondition = condition
    },
    async callDelete(id) {
      let payload = {
        portId: this.selectedPort.id,
        id: id,
      }
      this.$vs.loading()
      await this.deleteBerth(payload)
      this.$vs.notify({
        title: "データを削除しました。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center"
      })
      this.$vs.loading.close()
      let condition = {
        limit: this.displayItems.number,
        page: 0,
      }
      this.callSearch(condition)
    },
    async callUpdateOrder(sortOrders) {
      this.storedSearchKeyword = ""
      let payload = {
        portId: this.selectedPort.id,
        body: {
          sort_orders: sortOrders
        }
      }
      this.$vs.loading()
      await this.updateBerthOrders(payload)
      this.$vs.loading.close()
      let condition = {
        limit: this.displayItems.number,
        page: 0,
      }
      this.callSearch(condition)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
